import JobCard from './job-card'

export default JobCard
